import { render } from "./FoodView.vue?vue&type=template&id=2d45ad3a"
import script from "./FoodView.vue?vue&type=script&lang=js"
export * from "./FoodView.vue?vue&type=script&lang=js"

import "./FoodView.vue?vue&type=style&index=0&id=2d45ad3a&lang=scss"
import "./FoodView.vue?vue&type=style&index=1&id=2d45ad3a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__